export default {
  baseUrl: import.meta.env.VITE_API_BASE_URL,
};
